// Per-user, per-device Ask Eli floating-button position (localStorage; never in tenant business data).
const key = (bid, uid) => `neec_eli_pos_${bid || "main"}_${uid || "anon"}`;
export const EVT = "neec-eli-position";

export function loadEliPosition(bid, uid) {
  try { const v = JSON.parse(localStorage.getItem(key(bid, uid)) || "null"); return v && typeof v.bottom === "number" ? v : null; } catch { return null; }
}
export function saveEliPosition(bid, uid, pos) {
  localStorage.setItem(key(bid, uid), JSON.stringify({ ...pos, updated_at: new Date().toISOString() }));
  window.dispatchEvent(new CustomEvent(EVT));
}
export function resetEliPosition(bid, uid) {
  localStorage.removeItem(key(bid, uid));
  window.dispatchEvent(new CustomEvent(EVT));
}
